import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { BrowserRouter } from 'react-router-dom';
import { msalConfig } from "./authConfig";
import AppContent from './components/AppContent';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import './App.css';

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MsalProvider instance={msalInstance}>
        <BrowserRouter future={{ 
          v7_startTransition: true,
          v7_relativeSplatPath: true 
        }}>
          <AppContent />
        </BrowserRouter>
      </MsalProvider>
    </ThemeProvider>
  );
}

export default App;
